import { AppType } from "@common/types/sharedTypes";

/**
 * Only Beam and Column let the user pick a material when a new file is created.
 * The other app types either seed the material from their own template
 * (Foundation, Frame, Section) or have no material at all
 * (Retaining Wall, Basement Wall, Pile, CPT).
 */
export const appTypeRequiresMaterial = (appType: AppType | null): boolean =>
  appType === AppType.SIMPLEX_APP_BEAM || appType === AppType.SIMPLEX_APP_COLUMN;

/**
 * Display names for the app types Center can hold files for, in the order they should
 * appear in menus and filters. A type missing from this list renders as "Unknown".
 */
export const APP_TYPE_LABELS: ReadonlyArray<{ appType: AppType; label: string }> = [
  { appType: AppType.SIMPLEX_APP_BEAM, label: "Beam" },
  { appType: AppType.SIMPLEX_APP_FOUNDATION, label: "Foundation" },
  { appType: AppType.SIMPLEX_APP_COLUMN, label: "Column" },
  { appType: AppType.SIMPLEX_APP_FRAME, label: "Frame" },
  { appType: AppType.SIMPLEX_APP_SECTION, label: "Section" },
  { appType: AppType.SIMPLEX_APP_RETAININGWALL, label: "Retaining Wall" },
  { appType: AppType.SIMPLEX_APP_BASEMENT_WALL, label: "Basement Wall" },
  { appType: AppType.SIMPLEX_APP_PILE, label: "Pile" },
  { appType: AppType.SIMPLEX_APP_CPT, label: "CPT" },
];

/** Display name for an app type, or "Unknown" for anything unrecognised. */
export const getAppTypeLabel = (appType: AppType | null): string =>
  APP_TYPE_LABELS.find((entry) => entry.appType === appType)?.label ?? "Unknown";
